"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCssClassByProps = void 0;

const createCssClassByProps = props => {
  const {
    color,
    size,
    fontType,
    kind,
    align,
    segment,
    className,
    lineHeight,
    display,
    backgroundColor,
    decoration,
    border
  } = props;
  const kindSegment = `${kind}-${segment}`;
  const background = backgroundColor ? `${kind}-${segment}--${backgroundColor}-background` : '';
  const displaycss = display ? `${kind}--${display}` : '';
  const ownCss = className ? ` ${className}` : '';
  const decorationCss = `${kind}-decoration--${decoration}`;
  const borderCss = `${kind}-border--${border}`;
  const lineHeightCss = lineHeight ? `lh-${lineHeight}` : '';
  return `${kind} ${kindSegment}--${size} ${kindSegment}--${size}--${lineHeightCss} ${kindSegment}--${fontType} ${kind}--${align} ${kindSegment}--${color} ${background}${ownCss} ${displaycss} ${decorationCss} ${borderCss}`;
};

exports.createCssClassByProps = createCssClassByProps;

//# sourceMappingURL=utils.js.map